import { FC } from "react";
import Switch from "react-switch";

interface TooglePropTypes {
  checked: boolean;
  onChange: () => void;
}

const Toogle: FC<TooglePropTypes> = ({ checked, onChange }) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      uncheckedIcon={false}
      checkedIcon={false}
      onColor="#1570EF"
      width={36}
      height={20}
    />
  );
};

export default Toogle;
